import useUser from "../../../hooks/useUser";
import { useMemo } from "react";

export const useCanUserAddOrRemoveNotes = (petData, isPetLoading = false) => {
  const { currentClinic, roles, profile } = useUser();
  const loggedInUserId = profile.id; 
  const canUser = useMemo(() => {
    if (isPetLoading) return false;

    if (!petData || !loggedInUserId || !roles) {
      return false;
    }

    if (roles.master) {
      return true;
    }

    // Regular users can add/remove notes for their own pets
    if (roles.user) {
      return Number(petData.userId) === Number(loggedInUserId);
    }

    // Clinic admins/employees can add/remove notes for pets associated with their clinic
    if (roles.adminOrEmployee) {
      // Flat PetGeneralTabDto fields: clinic-owned pet, or the owner's clinic
      const petClinicId = petData?.clinicId || petData?.ownerClinicId;
      if (!petClinicId || !currentClinic) return false;
      return Number(currentClinic.id) === Number(petClinicId);
    }

    return false;
    
  }, [petData, loggedInUserId, roles, currentClinic, isPetLoading]);
  return canUser;
};
